import { defineStore } from 'pinia'

type PlayerData = {
  name: string
  color: string
  broadcastDice: boolean
}

interface ResolvedInlinePage {
  title: string
  id: string
  href: string
  depth: number
}

export const useStore = defineStore('estia', {
  state: () => ({
    resolvedInlinePages: {} as Record<string, ResolvedInlinePage>,
    playerData: { name: 'Player', color: '#e27e29', broadcastDice: false } as PlayerData,
  }),
  persist: true,
})
